import React, { useEffect, useState } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import Testimonial from "../components/Testimonial";
import MainNews from "../components/MainNews";
import Pricing from "../components/Pricing";
import FAQ from "../components/Faqs";
import TestimonialOne from "../components/TestimonialOne";
import DemoRequestModal from "../components/DemoModal";
import Features from "../components/Features";
import Header from '../components/Header';
import Footer from '../components/Footer';

function Home() {
  const [show, setShow] = useState(false)
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    AOS.init({
      duration: 2000, // Animation duration
      once: true, // Animation occurs once per scroll
    });
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);

  }, []);

  useEffect(() => {
    const handleMouseMove = (event) => {
      setPosition({ x: event.clientX, y: event.clientY });
    };

    document.addEventListener("mousemove", handleMouseMove);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);
  const handleOpen = (v) => {
    setShow(true)
  }

  const data1 = [
    {
      title: "Scalability  & Performance",
      icon: "assets/img/icon3.svg",
      description: "Utilize cloud hosting for scalability, ensuring can grow with your user base.Ensure that the system can handle varying loads"
    },
    {
      title: "Continuous Improvement",
      icon: "assets/img/icon1.svg",
      description: "Using agile methodologies to iteratively improve the platform based on user feedback and changing needs."
    },
    {
      title: "Security & Compliance",
      icon: "assets/img/icon2.svg",
      description: "Ensure that users have access only to the information relevant to their roles.Tools for tracking compliance"
    },
  ]


  return (
    <React.Fragment>
      <div
        style={{
          position: "fixed",
          top: position.y,
          left: position.x,
          width: "25px",
          height: "25px",
          backgroundColor: "rgba(87, 168, 255, 0.15)",
          borderRadius: "50%",
          zIndex: 22,
          pointerEvents: "none",
          transform: "translate(-50%, -50%)",
          transition: "transform 0.1s ease-out",
        }}
      />
      <div className="media-icons">
        <a href="https://wa.me/918448848632 " className="whatsap-icon" ><i className="fa-brands fa-whatsapp"></i></a>
        <a href="mailto:hrms@cvinfotech.com" className="mail-icon"><i className="fa-regular fa-envelope"></i></a>
      </div>
      <main className="second-landing-page">
        <Header handleOpen={handleOpen} />
        {/* banner */}
        <div className="main-banner-section"
          data-aos="fade-up" data-aos-duration="2000"
        >
          <div className="home-section-vector-left-top"><img src="assets/img/backleftTop.png" alt="vector-image" style={{ width: "350px" }} /></div>
          {/* <div className="home-section-vector-left-bottom"><img src="assets/img/vector/vector-home-left-bottom.png" alt="vector-image" /></div> */}
          <div className="home-section-vector-right-top"><img src="assets/img/vector/vector-home-top.png" alt="vector-image" /></div>
          {/* <div className="home-section-vector-right-bottom"><img src="assets/img/vector/vector-home-bottom.png" alt="vector-image" /></div> */}
          <div className="container">
            <div className="row">
              <div className="homepage-section d-flex justify-content-center">
                <div className="col-lg-5 col-sm-5 col-12 d-flex align-items-center">
                  <div className="process-content">

                    <h1 className="mb-2 text-dark aos-init aos-animate"
                    style={{fontSize:"69px"}}
                    data-aos="fade-up" data-aos-duration="1500">
                      {/* Future-Ready HR for a Dynamic Workplace. */}
                      Bring all your work together
                    </h1>
                    {/* <p data-aos="fade-up" data-aos-duration="1500" data-aos-delay="300" data-aos-once="true" className="text-gray">Prepare your HR department for the future with our adaptable HRMS, designed to meet the needs of a dynamic workplace and foster a culture of continuous improvement.</p> */}
                    <p data-aos="fade-up" data-aos-duration="1500" data-aos-delay="300" data-aos-once="true" className="text-gray">
                      A better experience for HR’s and less stress for your team.
                    </p>

                    {/* <a href="#" className="d-inline-flex align-items-center btn btn-primary aos-init aos-animate" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="400" data-aos-once="true">Book a Demo <i className="ti ti-arrow-right ms-1"></i></a> */}
                    <button className="req-btn" onClick={handleOpen} data-aos="fade-up" data-aos-duration="1500" data-aos-delay="400" data-aos-once="true">Book a Demo
                      <svg width="18" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /><path d="M15 16l4 -4" /><path d="M15 8l4 4" /></svg>
                    </button>
                    <div className="banner-users py-4 d-flex gap-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="500" data-aos-once="true">
                      {/* <div className="avatar-list-stacked avatar-group-lg me-2">
                        <span className="avatar avatar-lg rounded-circle "><img src="/assets/img/Applepie.png" className="img-fluid rounded-circle " alt="Img" style={{ width: "50px", height: "50px" }} /></span>
                        <span className="avatar avatar-lg rounded-circle "><img src="/assets/img/Fitme.png" className="img-fluid rounded-circle " alt="Img" style={{ width: "50px", height: "50px" }} /></span>
                        <span className="avatar avatar-lg rounded-circle "><img src="/assets/img/pet.png" className="img-fluid rounded-circle border border-white" alt="Img" style={{ width: "50px", height: "50px" }} /></span>
                      </div> */}
                      {/* <div className="d-flex flex-column align-items-center justify-content-center">
                        <div className="d-flex align-items-center  gap-1 bold m-0">
                          <div className="d-flex align-items-center m-0">
                            {
                              [1, 2, 3, 4, 5]?.map((item) => {
                                return (
                                  <i key={item} className="fa-solid fa-star " style={{ color: "gold" }}></i>
                                )
                              })
                            }
                          </div>
                          <p className="m-0 p-0">5.0 Ratings</p>
                        </div>
                      </div> */}
                    </div>

                  </div>
                </div>
                <div className="col-lg-7 col-sm-7 col-12">
                  <div className="main-slider">
                    {/* <div className="slider-vector-layer"><img src="assets/img/vector/slider-vector-bottom-left.png" alt="vector-image" /></div> */}
                    {/* <div className="slider-vector-layers"><img src="assets/img/vector/slider-vector-bottom-right.png" alt="vector-image" /></div> */}
                    <div className="slider-vector-top-left"><img src="assets/img/vector/slider-vector-top.png" alt="vector-image" /></div>
                    <div className=" rounded" 
                    // style={{ transform: "translateY(26px)" }}
                    >
                      <img src="assets/img/newBanner2.png" alt="main-slider" />
                      {/* <img src="assets/img/OBJECTS.png" alt="main-slider" /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* fe */}
        <div className="main-subscribe " id="contact" data-aos="fade-up" data-aos-duration="2000">
          <div className="container">
            <div className="row">
              <div className="main-subscribe-content">
                <div className="subscribe-vector-left"><img src="assets/img/vector/subscribe-left.png" alt="img" /></div>
                <div className="subscribe-vector-bottom"><img src="assets/img/vector/subscribe-center.png" alt="img" /></div>
                <div className="subscribe-vector-right"><img src="assets/img/vector/subscribe-right.png" alt="img" /></div>
                <div className="text-start pl-3 title pb-2">
                  <h2 data-aos="fade-up" data-aos-duration="1500" data-aos-once="true" className="text-white bold">Developing company values for a<br className="d-none d-lg-block" /> HRMS Software</h2>
                </div>
                <div className="row justify-content-center ">
                  {
                    data1?.map((item, index) => {
                      return (
                        <div key={index} className="col-md-6 col-lg-4 col-12 mb-2 ">
                          <div className="card aos-init aos-animate" data-aos="flip-left" data-aos-duration="1500" data-aos-once="true">
                            <div className="card-body sv-card-body">
                              <span className="hrms-software-icon">
                                <img src={item?.icon} alt={item?.title} />
                              </span>
                              <h3>{item?.title}</h3>
                              <p className="text-gray-5  line-clamb-3">
                                {item?.description}
                              </p>
                            </div>

                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Testimonial */}
        <Testimonial />
        {/* features 1 */}
        <Features handleOpen={handleOpen} />
        {/* pricing */}
        <Pricing handleOpen={handleOpen} />
        {/* faq */}
        <FAQ handleOpen={handleOpen} />
        {/* TestimonialOne */}
        <TestimonialOne />
        {/* main news */}
        {/* <MainNews /> */}
        <DemoRequestModal show={show} handleClose={() => { setShow(false) }} />
        <Footer />
      </main>
      <div className="back-to-top">
        <a className={`back-to-top-icon align-items-center justify-content-center d-flex ${showBackToTop ? "show" : ""}`} href="#top"><i className="fa-solid fa-arrow-up"></i></a>
      </div>

    </React.Fragment>
  );
}


export default Home
